import { BaseModel } from './base.model';
import { Client } from './client.model';
import { Subsystem } from './subsystem.model';
import { Technology } from './technology.model'; // NUEVO 1c

export interface System {
    id: number;
    name: string;
    description: string;
    frameworkVersion: string;
    nameSlug?: string;
    client: Client;
    subsystems: Subsystem[];
    technologies: Technology[]; // NUEVO 1c
}

export class System implements BaseModel {
    id: number;
    name: string;
    description: string;
    frameworkVersion: string;
    nameSlug?: string;
    client: Client;
    subsystems: Subsystem[];
    technologies: Technology[]; // NUEVO 1c

    constructor();
    constructor(id: number, name: string, description: string, frameworkVersion: string, client: Client, subsystems: Subsystem[], technologies: Technology[]);

    constructor(id?: number, name?: string, description?: string, frameworkVersion?: string, client?: Client, subsystems?: Subsystem[], technologies?: Technology[]) {
      if (id !== undefined) {
        this.id = id;
      }

      if (name !== undefined) {
        this.name = name;
      } else {
        this.name = '';
      }

      if (description !== undefined) {
        this.description = description;
      } else {
        this.description = '';
      }

      if (frameworkVersion !== undefined) {
        this.frameworkVersion = frameworkVersion;
      } else {
        this.frameworkVersion = '';
      }

      if (client !== undefined) {
        this.client = client;
      } else {
        this.client = {} as Client;
      }

      if (subsystems !== undefined) {
        this.subsystems = subsystems;
      } else {
        this.subsystems = [];
      }

      if (technologies !== undefined) {
        this.technologies = technologies;
      } else {
        this.technologies = [];
      }
    }

    getApiName(): string {
      return 'system';
    }

    getName(): string {
      return 'Sistema';
    }

    getNamePl(): string {
      return 'Sistemas';
    }
  }